import angular from 'angular';
import ngResource from 'angular-resource';

import drivers from './drivers';
import shifts from './shifts';
import stores from './stores';
import schedules from './schedules';
import alerts from './alerts';
import audit from './audit';
import user from './user';
import reports from './reports';
import perf from './perflogger';
import dateService from './dateservice';

const services = angular.module('services', [ngResource]);

services.service('DriversService', drivers);
services.service('ShiftsService', shifts);
services.service('StoresService', stores);
services.service('SchedulesService', schedules);
services.service('Alerts', alerts);
services.service('AuditService', audit);
services.service('UserService', user);
services.service('ReportsService', reports);
services.service('PerfLogger', perf);
services.service('DateService', dateService);

export default services.name;



// WEBPACK FOOTER //
// ./src/js/services/index.js